export default __webpack_public_path__ + "static/media/defaultkit.1d16aef8.svg";